import React, { useState, useEffect } from 'react';
import { Card, ListGroup, Badge, Button, Spinner } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';
import { API_BASE_URL } from '../../config/api';

export default function UnreadMessagesWidget() {
  const [messages, setMessages] = useState([]);
  const [loading, setLoading] = useState(true);
  const { apiCall } = useAuth();
  const navigate = useNavigate();

  const loadMessages = async () => {
    try {
      setLoading(true);
      const response = await apiCall(`${API_BASE_URL}/communications/unread?limit=5`);
      setMessages(response.data || []);
    } catch (error) {
      console.error('Failed to load unread messages:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadMessages();
    const interval = setInterval(loadMessages, 30000); // Refresh every 30s
    return () => clearInterval(interval);
  }, []);

  const handleMarkAsRead = async (id, e) => {
    e.stopPropagation();
    try {
      await apiCall(`${API_BASE_URL}/communications/${id}/mark-read`, { method: 'POST' });
      await loadMessages();
    } catch (error) {
      console.error('Failed to mark as read:', error);
    }
  };

  const handleNavigateToCustomer = (customerId) => {
    navigate(`/dashboard/customers/${customerId}`, { state: { focusSms: true } });
  };

  return (
    <Card className="shadow-sm">
      <Card.Header className="text-white d-flex justify-content-between align-items-center" style={{ backgroundColor: '#6366f1' }}>
        <div>
          <i className="fas fa-envelope me-2"></i>
          Unread Messages
          {messages.length > 0 && (
            <Badge bg="danger" className="ms-2">{messages.length}</Badge>
          )}
        </div>
        <Button
          variant="light"
          size="sm"
          onClick={loadMessages}
          disabled={loading}
        >
          <i className="fas fa-sync-alt"></i>
        </Button>
      </Card.Header>
      <Card.Body className="p-0">
        {loading ? (
          <div className="text-center p-4">
            <Spinner animation="border" size="sm" />
          </div>
        ) : messages.length === 0 ? (
          <div className="text-center text-muted p-4">
            <i className="fas fa-check-circle fa-2x mb-2"></i>
            <p className="mb-0">All caught up!</p>
          </div>
        ) : (
          <ListGroup variant="flush">
            {messages.map((msg) => (
              <ListGroup.Item
                key={msg.id}
                onClick={() => handleNavigateToCustomer(msg.customer_id)}
                style={{ cursor: 'pointer' }}
              >
                <div className="fw-bold">
                  {msg.first_name} {msg.last_name}
                  <small className="text-muted ms-2">{msg.phone_number}</small>
                </div>
                <div className="text-muted small">
                  {msg.content.substring(0, 60)}
                  {msg.content.length > 60 && '...'}
                </div>
                <small className="text-muted">
                  {new Date(msg.created_at).toLocaleString()}
                </small>
                <div className="mt-2">
                  <Button
                    variant="outline-success"
                    size="sm"
                    onClick={(e) => handleMarkAsRead(msg.id, e)}
                  >
                    <i className="fas fa-check me-1"></i>
                    Mark Read
                  </Button>
                </div>
              </ListGroup.Item>
            ))}
          </ListGroup>
        )}
      </Card.Body>
    </Card>
  );
}
